import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import moment               from 'moment';

let Quote = require('../Managers/Quote');

class SiteFooter extends Component {
    render() {
        return(
            <footer className="site-footer">
                <div className="container">
                    {!window.uornorb(Quote.getByPath('domainInfo.brand')) ?
                        <p className="copyright">&copy; {moment().year()} <span dangerouslySetInnerHTML={{__html: Quote.getByPath('domainInfo.brand')}} />. All rights reserved</p>
                    : null}
                    <div id="copyright-notice">
                    {!window.uornorb(Quote.getByPath('domainInfo.copyrightNotice')) ?
                        <div dangerouslySetInnerHTML={{__html: Quote.getByPath('domainInfo.copyrightNotice')}} />
                    : null}
                    </div>
                    <p>Build {this.props.version}</p>
                </div>
            </footer>
        );
    }
}

SiteFooter.propTypes = {
    version: PropTypes.string.isRequired,
};

export default SiteFooter;


// WEBPACK FOOTER //
// ./src/components/Fragments/SiteFooter.js